import { VipPackage } from '../models/announcement.model';

export const MOCK_VIP_PACKAGES: VipPackage[] = [
  { id: '1-day', days: 1, price: 5.00 },
  { id: '5-days', days: 5, price: 10.00 },
  { id: '15-days', days: 15, price: 20.00 },
  { id: '30-days', days: 30, price: 30.00 }
];
